import { CopyOutlined, DownOutlined, RightOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import { DeleteIcon } from "../../../../../../../assets/svg";
import { AppButton } from "../../../../../../atoms/Button";
import { formatCurrency, formatDateByType } from "../../../../../../libs/utils";
import { useBookingSelector } from "../../../../hooks/useBookingSelector";

const { Text } = Typography;

type YearCardHeaderProps = {
  yearNumber: number;
  isBreakdownGenerated: boolean;
  installmentsCount?: number;
  annualRent?: number;
  breakdownStartDate?: string;
  planIndex: number;
  isExpanded: boolean;
  onCopyFromPreviousYear: (e: React.MouseEvent) => void;
  canCopyFromPreviousYear: boolean;
  onRemove: () => void;
};

export const YearCardHeader = (props: YearCardHeaderProps) => {
  const {
    yearNumber,
    isBreakdownGenerated,
    installmentsCount,
    annualRent,
    breakdownStartDate,
    planIndex,
    isExpanded,
    onCopyFromPreviousYear,
    canCopyFromPreviousYear,
    onRemove,
  } = props;

  const { isPaymentPlanApprovalSent } = useBookingSelector();

  const subHeaderStyles = {
    fontSize: 12,
    fontWeight: 600,
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "2rem" }}>
        <Text strong style={{ fontSize: 16 }}>
          YEAR {yearNumber}
        </Text>

        {isBreakdownGenerated && (
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Text type="secondary" style={subHeaderStyles}>
              Rent: {formatCurrency(annualRent ?? 0)}
            </Text>
            <Text type="secondary">•</Text>
            <Text type="secondary" style={subHeaderStyles}>
              From: {formatDateByType(breakdownStartDate)}
            </Text>

            {installmentsCount && (
              <>
                <Text type="secondary">•</Text>
                <Text type="secondary" style={subHeaderStyles}>
                  {installmentsCount} Installments
                </Text>
              </>
            )}
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {!isPaymentPlanApprovalSent && planIndex > 0 && (
          <AppButton
            variant="outlined"
            size="small"
            icon={<CopyOutlined />}
            onClick={onCopyFromPreviousYear}
            disabled={!canCopyFromPreviousYear}
          >
            Copy from Year {planIndex}
          </AppButton>
        )}
        {!isPaymentPlanApprovalSent && (
          <AppButton
            variant="icon"
            size="small"
            icon={<DeleteIcon />}
            aria-label="Remove year"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          />
        )}
        {isExpanded ? (
          <DownOutlined style={{ fontSize: 12, color: "var(--gray-500)" }} />
        ) : (
          <RightOutlined style={{ fontSize: 12, color: "var(--gray-500)" }} />
        )}
      </div>
    </>
  );
};
